module.exports = __webpack_public_path__ + "static/media/strategy.ac8809fa.svg";